import * as React from 'react'
import styled, { css } from 'styled-components'

const Wrapper = styled.header<{ $isLink?: boolean }>`
  color: inherit;
  cursor: ${({ $isLink }) => ($isLink ? 'pointer' : 'default')};
  display: block;
  position: relative;
  text-decoration: none;
  min-height: 1.25rem;
  margin-bottom: 0.5rem;

  ${({ $isLink }) =>
    $isLink &&
    css`
      &:before {
        background: transparent;
        border-radius: 0.75rem;
        bottom: 0;
        content: '';
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        transition: all 0.13s;
        z-index: 1;
      }

      &:hover:before {
        background: ${p => p.theme.colors.black[6]};
        bottom: -2px;
        left: -2px;
        right: -2px;
        top: -2px;
      }
    `}
`

const InnerContent = styled.div`
  position: relative;
  z-index: 2;
`

const Title = styled.h3`
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.black[4]};
  font-weight: 600;
  padding: 0 0.4rem;
`

const Subline = styled.div`
  color: ${({ theme }) => theme.colors.black[3]};
  font-size: 0.7rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export interface GroupHeaderProps {
  title: string
  subline?: string
  as?: React.ElementType
  [key: string]: any
}

export const GroupHeader = ({ title, subline, as, ...rest }: GroupHeaderProps) => {
  const isLink = !!rest.href || !!rest.to

  return (
    <Wrapper as={as} $isLink={isLink} {...rest}>
      <InnerContent>
        {!!title && <Title>{title}</Title>}
        {!!subline && <Subline title={subline}>{subline}</Subline>}
      </InnerContent>
    </Wrapper>
  )
}
